import { ChevronLeft, ChevronRight } from 'lucide-react';

/** Paginación del lado del servidor (`meta.page`, `meta.pageSize`, `meta.total`). */
export function Paginador({
  page,
  pageSize,
  total,
  onPage,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
}) {
  const paginas = Math.max(1, Math.ceil(total / pageSize));
  const desde = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const hasta = Math.min(total, page * pageSize);
  return (
    <nav aria-label="Paginación" className="flex items-center justify-between gap-3 pt-4 text-sm">
      <p className="text-texto-2">
        {desde}–{hasta} de {total.toLocaleString('es-MX')}
      </p>
      <div className="flex items-center gap-1">
        <button
          type="button"
          className="btn-cs btn-contorno px-2 py-1"
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          aria-label="Página anterior"
        >
          <ChevronLeft size={16} />
        </button>
        <span className="px-2 font-bold">
          {page} / {paginas}
        </span>
        <button
          type="button"
          className="btn-cs btn-contorno px-2 py-1"
          disabled={page >= paginas}
          onClick={() => onPage(page + 1)}
          aria-label="Página siguiente"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </nav>
  );
}
